import { Box, Text, Container, chakra } from "@chakra-ui/react";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import PageInfo from "@/components/PageInfo";

export default function Mission() {
  return (
    <>
      <PageInfo
        title="Mission"
        description="We're dedicated to building a better, more accessible model for college apps."
        themeColor="beige"
      />
      <Box bg="beige">
        <Navbar />
        <Container maxW="container.md">
          <chakra.h1 textStyle="pageHeader" textAlign={{ base: "left", md: "center" }} mt={10}>
            Our Mission
          </chakra.h1>
          <Box borderRadius="xl" fontSize="xl">
            <Text mt={4}>
              As Stanford students newly distanced from the college application process ourselves,
              we built AdmitYogi with the desire to make applying to college easier & more
              affordable. Based on our experiences, consultants were often not worth their hefty
              price tag and, considering they applied to college decades ago, they lacked relevant
              exposure & expertise.
            </Text>
            <Text mt={4}>
              Conversely, free resources were far and few between. What we could find wasn’t
              verified, nor did it come from applicants with similar backgrounds to our own. As an
              example, when one of us wanted to find the essays, activities, and awards of an Asian
              male CS applicant who got into Stanford, we weren’t able to.
            </Text>
            <Text mt={4}>
              Before AdmitYogi, there was no way to easily search through a database of successful
              college applications and find folks just like you.
            </Text>
            <Text mt={4}>
              Now, using our sophisticated searching algorithm & advanced ranking features, you can
              find students, with similar backgrounds to your own, studying at your dream school.
              Then, for a limited price, you can read their entire application: their essays,
              activities, awards, and more.
            </Text>
            <Text mt={4}>
              Best of all, if you enjoy the writing style of that applicant, you can read through
              their acceptances and writing qualifications. If you think they could provide a
              valuable second set of eyes, our platform empowers you to have them edit your essay
              (all at a cost that is a fraction of what consultants charge).
            </Text>
            <Text mt={4}>
              The nature of college consulting hasn’t changed in decades, even though the realities
              of the college application landscape change on an annual basis. We’re here to change
              that—and we hope you join us in supporting our mission.
            </Text>
            <Text mt={4} style={{ textAlign: "right", color: "gray", fontStyle: "italic" }}>
              — Soham, Atman, and Ananth
            </Text>
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
